// extracted by mini-css-extract-plugin
export default {"btn":"MainButton_btn__iRQ9a","btn__animation":"MainButton_btn__animation__m9IrJ","bottom-up":"MainButton_bottom-up__Pjbpq"};